import { render, staticRenderFns } from "./simDeleteRecord.vue?vue&type=template&id=c44cda6a&scoped=true&"
import script from "./simDeleteRecord.vue?vue&type=script&lang=js&"
export * from "./simDeleteRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44cda6a",
  null
  
)

export default component.exports